'use client';

import { VixRuleResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  result: VixRuleResult;
  translations: ToolsTranslations['vixRule'];
}

export default function ResultsDisplay({ result, translations }: Props) {
  const daily = result.dailyMovePercent ?? 0;
  // Show up to 2 decimals but omit unnecessary trailing zeros (e.g., 150 % instead of 150.0 %)
  const formatted = new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(daily);

  return (
    <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-800 mb-2">{translations.resultLabel}</h3>
      {!result.isValid && result.message && (
        <p className="text-sm text-red-600 mb-4" role="alert">{result.message}</p>
      )}
      <p className="text-3xl font-bold text-green-700">{formatted} %</p>
      <p className="text-gray-600 mt-3 text-sm">{translations.formulaNote}</p>
    </div>
  );
}


